import { t } from "i18next";
import { isEditorEmpty } from "neetoeditor";
import { prop } from "ramda";
import * as yup from "yup";

export const INITIAL_FORM_VALUES = {
  sendTo: [],
  sendToId: "",
  sendToCc: [],
  sendToBcc: [],
  replyTo: "",
  showCopyEmails: false,
  subject: "",
  message: "",
  isEnabled: false,
};

export const EMAIL_FORM_VALIDATION_SCHEMA = yup.object({
  subject: yup
    .string()
    .required(t("neetoMolecules.emailForm.errors.subjectRequired")),
  message: yup
    .string()
    .test(
      "message",
      t("neetoMolecules.emailForm.errors.messageRequired"),
      value => !isEditorEmpty(value)
    ),
});

export const sendToFieldValidation = maxEmails => {
  const validation = yup
    .array()
    .test(
      "all-emails-valid",
      t("neetoMolecules.emailForm.errors.invalidEmailAddress"),
      emails => emails?.every(prop("valid"))
    )
    .test(
      "max-email-count",
      t("neetoMolecules.emailForm.errors.maxEmails", { count: maxEmails }),
      emails => emails?.length <= maxEmails
    );

  return yup.object({
    sendTo: validation
      .min(
        1,
        t("neetoMolecules.emailForm.errors.required", {
          entity: t("neetoMolecules.emailForm.fields.sendToEmailAddress"),
        })
      )
      .nullable(),
    sendToCc: validation,
    sendToBcc: validation,
  });
};

export const SEND_TO_ID_FIELD_VALIDATION = yup.object({
  sendToId: yup.string().required(
    t("neetoMolecules.emailForm.errors.required", {
      entity: t("neetoMolecules.emailForm.labels.sendTo"),
    })
  ),
});

export const REPLY_TO_FIELD_VALIDATION = yup.object({
  replyTo: yup
    .string()
    .nullable()
    .email(t("neetoMolecules.emailForm.errors.invalidEmailAddress"))
    .required(
      t("neetoMolecules.emailForm.errors.required", {
        entity: t("neetoMolecules.emailForm.fields.replyToEmailAddress"),
      })
    ),
});

export const EDITOR_ADDONS = [
  "highlight",
  "emoji",
  "code-block",
  "block-quote",
  "image-upload",
  "divider",
  "video-embed",
];

export const ALLOWED_FILE_PICKER_TYPES = [".csv"];
